import React from "react";
// import { Parallax } from "react-scroll-parallax";

const Perform2023EmbedSection = ({ data }) => {
    return (
        <div className="cp-perform2023Embed">
            <div className="cp-perform2023Embed__inner" data-aos="fade-up">
                {data.perform23EmbedSectionHeader &&
                    <h2>{data.perform23EmbedSectionHeader}</h2>
                }
                {/* <Parallax y={[0, 0]} speed={-10}> */}
                {data.perform23EmbedSectionScriptToEmbed &&
                    <div className="l-embedSection" dangerouslySetInnerHTML={{ __html: data.perform23EmbedSectionScriptToEmbed }} />
                }
                {/* </Parallax> */}
                {data.perform23EmbedSectionCta &&
                    <div className="l-buttonWrap">
                        <div className="l-relativeButton">
                            <a className="l-button" href={data.perform23EmbedSectionCta.url} target={data.perform23EmbedSectionCta.target}>{data.perform23EmbedSectionCta.title}</a>
                            <a className="l-button l-backgroundHover" href={data.perform23EmbedSectionCta.url} target={data.perform23EmbedSectionCta.target}>{data.perform23EmbedSectionCta.title}</a>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export default Perform2023EmbedSection;

